import React from "react";
import { Badge } from "antd";

export const TICKET_STATUS = {
  1: { label: "در انتظار بررسی", color: "#faad14", badge: "warning", key: "open" },
  2: { label: "در انتظار پشتیبانی", color: "#1677ff", badge: "processing", key: "pending" },
  3: { label: "پاسخ داده شد", color: "#52c41a", badge: "success", key: "answered" },
  4: { label: "بسته شده", color: "#94a3b8", badge: "default", key: "closed" },
};

export const getStatusMeta = (status) =>
  TICKET_STATUS[status] || {
    label: "نامشخص",
    color: "#94a3b8",
    badge: "default",
    key: "unknown",
  };

export const TICKET_PRIORITY = {
  low: { label: "پایین", color: "#94a3b8" },
  normal: { label: "متوسط", color: "#1677ff" },
  high: { label: "بالا", color: "#f57c00" },
  urgent: { label: "بحرانی", color: "#d32f2f" },
};

export const getPriorityMeta = (priority) =>
  TICKET_PRIORITY[priority] || { label: priority || "-", color: "#94a3b8" };

const ColorDot = ({ color }) => (
  <span
    style={{
      width: 8,
      height: 8,
      borderRadius: "50%",
      background: color,
      display: "inline-block",
      flexShrink: 0,
    }}
  />
);

export const statusSelectOptions = Object.entries(TICKET_STATUS).map(
  ([value, meta]) => ({
    value: Number(value),
    label: <Badge status={meta.badge} text={meta.label} />,
    text: meta.label,
  })
);

export const prioritySelectOptions = Object.entries(TICKET_PRIORITY).map(
  ([value, meta]) => ({
    value,
    label: (
      <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
        <ColorDot color={meta.color} />
        {meta.label}
      </span>
    ),
    text: meta.label,
  })
);
